import React, { useEffect } from "react";
import { message } from "antd";

const Home = () => {
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
       messageApi.success(`Bienvenido`);
      // eslint-disable-next-line
    }, []);

  return (
    <div>
      {contextHolder}
    </div>
  );
};

export default Home;
